import { render, staticRenderFns } from "./module-setting.vue?vue&type=template&id=71a82d84&scoped=true&"
import script from "./module-setting.vue?vue&type=script&lang=js&"
export * from "./module-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a82d84",
  null
  
)

export default component.exports